import type { Step } from "react-joyride";

/**
 * Versione 1: corretta la frase che dava per scontate le righe (sul telefono la
 * lista è a schede). Non vale la pena far ripartire il tour a chi l'ha visto.
 */
export const clientiListVersion = 1;

export const clientiListSteps: Step[] = [
  {
    target: '[data-tour="clienti-search"]',
    title: "Cerca un cliente",
    content: (
      <p>
        Scrivi cognome, nome, email o telefono. La ricerca parte al click su{" "}
        <strong>Cerca</strong>.
      </p>
    ),
    placement: "bottom",
    skipBeacon: true,
  },
  {
    target: '[data-tour="clienti-table"]',
    title: "Apri il cliente",
    content: (
      <p>
        Un clic sulla riga — sul telefono, sulla scheda — apre l'anagrafica:
        dati, codice fiscale o partita IVA, bollette e pratiche collegate.
      </p>
    ),
    placement: "top",
    skipBeacon: true,
  },
  {
    target: '[data-tour="clienti-pagination"]',
    title: "Paginazione",
    content: (
      <p>
        20 clienti per pagina. Usa <strong>Precedente</strong> /{" "}
        <strong>Successiva</strong> per navigare.
      </p>
    ),
    placement: "top",
    skipBeacon: true,
  },
];
